
export default function fetchBuyItAgainData(){
    const numberOfProductsReturned = 18;
    return fetch(
        `/api/BuyAgain/GetBuyAgainSuggestions?requestedNumber=${numberOfProductsReturned}`
    ).then(response => response.json());
}